import { gql } from '@apollo/client';
import { ErrorMessageInfo, WarrantyInfoShared } from '../fragments';

export default gql`
  mutation createWarranty($input: WarrantyCreateInput!) {
    createWarranty(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      warranty {
        ...WarrantyInfoShared
      }
    }
  }
  ${WarrantyInfoShared}
  ${ErrorMessageInfo}
`;
